<template>
  <div class="books-details">
    <div class="content-box2">
      <!-- 提示2 -->
      <el-alert
        title="审核资质注意事项"
        type="warning"
        show-icon
        @click="mydata.dialogVisible = true"

      />
      <!-- 店铺信息 -->
      <p class="a-title">店铺信息</p>
      <el-form
        style="max-width: 343px"
        :model="mydata.form"
        :rules="mydata.rules"
        label-width="auto"
        class="demo-ruleForm"
        ref="myForm"
        label-position="top"
      >
        <div class="some-input">
          <el-form-item label="店铺平台" prop="shop_platform">
            <el-select
              v-model="mydata.form.shop_platform"
              placeholder="请选择店铺平台"
            >
              <el-option
                v-for="(item, index) in mydata.storePlatformArr"
                :key="index"
                :label="item.store_platform"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="店铺名称" prop="shop_name">
            <el-input
              v-model="mydata.form.shop_name"
              placeholder="请填写店铺名称"
            />
          </el-form-item>

          <el-form-item label="店铺链接" prop="shop_url">
            <el-input
              v-model="mydata.form.shop_url"
              placeholder="请填写店铺链接"
            />
          </el-form-item>

          <el-form-item label="店铺省份" prop="province">
            <el-select
              v-model="mydata.form.province"
              placeholder="请选择店铺省份"
            >
              <el-option v-for="(item,index) in mydata.provinceList" :key="index" :label="item.label" :value="item.name" />
              <!-- <el-option label="上海" value="shanghai" />
              <el-option label="河南" value="henan" /> -->
            </el-select>
          </el-form-item>

          <el-form-item label="联系人" prop="contact">
            <el-input
              v-model="mydata.form.contact"
              placeholder="请填写联系人"
            />
          </el-form-item>

          <el-form-item label="QQ号码" prop="qq">
            <el-input v-model="mydata.form.qq" placeholder="请填写QQ号码" />
          </el-form-item>

          <el-form-item label="手机号码" prop="phone">
            <el-input
              v-model="mydata.form.phone"
              placeholder="请填写手机号码"
            />
          </el-form-item>

          <!-- 验证码 -->
          <el-form-item label="手机验证码" prop="phone_code">
            <el-input
              class="mobile-code"
              v-model="mydata.form.phone_code"
              placeholder="手机验证码"
            />
            <el-button @click="submit" :disabled="mydata.btnDisabled">{{
              mydata.btnText
            }}</el-button>
          </el-form-item>

          <el-form-item label="公司名称" prop="company_name">
            <el-input
              v-model="mydata.form.company_name"
              placeholder="请填写公司名称"
            />
          </el-form-item>

          <el-form-item label="组织机构代码" prop="company_number">
            <el-input
              v-model="mydata.form.company_number"
              placeholder="请填写组织机构代码"
            />
          </el-form-item>

          <el-form-item label="通讯地址" prop="address">
            <el-input
              v-model="mydata.form.address"
              placeholder="请填写通讯地址"
            />
          </el-form-item>

          <el-form-item label="公司简介" prop="intro" style="min-height: 100px">
            <el-input
              v-model="mydata.form.intro"
              type="textarea"
              placeholder="请填写公司简介"
            />
          </el-form-item>

          <!-- <el-form-item label="组织机构代码" prop="resource">
            <el-radio-group v-model="mydata.form.resource">
              <el-radio value="yes">是</el-radio>
              <el-radio value="no">否</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <!-- </el-form> -->
        </div>

        <!-- 上传证件 -->
        <p class="a-title">上传证件</p>
        <div class="upload-cards">
          <!-- 提示3 -->
          <el-alert
            class="my-alert-3"
            title="请注意"
            description="所有照片必须jpg、png、gif或者jpeg格式且5M大小内"
            type="warning"
            show-icon
          />
          <!-- 三证合一单选框 -->
          <div style="max-width: 600px" class="demo-ruleForm">
            <el-form-item label="三证合一" prop="is_merge">
              <el-radio-group
                v-model="mydata.form.is_merge"
                @change="isMergeChange"
              >
                <el-radio :value="1">是</el-radio>
                <el-radio :value="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- 证件 -->
          <el-form-item prop="file_arr">
            <div class="upload-box">
              <!-- 第一个 -->
              <div class="item">
                <div class="left">
                  <span>*</span>
                  <span>出版物经营许可证:</span>
                </div>
                <div class="right">
                  <el-upload
                    :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
                    :auto-upload="true"
                    v-model:file-list="mydata.fileList1"
                    :show-file-list="true"
                    list-type="picture-card"
                    :before-upload="beforeUpload1"
                    :on-success="successFile1"
                    :on-remove="uploadRemove1"
                    :on-preview="uploadPreview1"
                    :on-change="uploadChange1"
                    accept=".jpg,.jpeg,.png,.gif"
                    :class="{ hiddenUpload: mydata.hiddenUpload1 }"
                  >
                    <el-icon><Plus /></el-icon>
                    <p class="upload-tip">点击上传出版物经营许可证</p>
                  </el-upload>
                  <el-dialog v-model="mydata.dialogVisible1">
                    <img width="100%" v-complete:src="mydata.dialogImageUrl1" />
                  </el-dialog>
                </div>
              </div>
              <!-- 三证合一 -->
              <div class="item" v-if="mydata.form.is_merge === 1">
                <div class="left">
                  <span>*</span>
                  <span>三证合一:</span>
                </div>
                <div class="right">
                  <el-upload
                    :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
                    :auto-upload="true"
                    v-model:file-list="mydata.fileList4"
                    :show-file-list="true"
                    list-type="picture-card"
                    :before-upload="beforeUpload4"
                    :on-success="successFile4"
                    :on-remove="uploadRemove4"
                    :on-preview="uploadPreview4"
                    :on-change="uploadChange4"
                    accept=".jpg,.jpeg,.png,.gif"
                    :class="{ hiddenUpload: mydata.hiddenUpload4 }"
                  >
                    <el-icon><Plus /></el-icon>
                    <p class="upload-tip">点击上传三证合一</p>
                  </el-upload>
                  <el-dialog v-model="mydata.dialogVisible4">
                    <img width="100%" v-complete:src="mydata.dialogImageUrl4" />
                  </el-dialog>
                </div>
              </div>
              <!-- 第二个 -->
              <div class="item" v-if="mydata.form.is_merge === 0">
                <div class="left">
                  <span>*</span>
                  <span>组织机构代码证:</span>
                </div>
                <div class="right">
                  <el-upload
                    :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
                    :auto-upload="true"
                    v-model:file-list="mydata.fileList2"
                    :show-file-list="true"
                    list-type="picture-card"
                    :before-upload="beforeUpload2"
                    :on-success="successFile2"
                    :on-remove="uploadRemove2"
                    :on-preview="uploadPreview2"
                    :on-change="uploadChange2"
                    accept=".jpg,.jpeg,.png,.gif"
                    :class="{ hiddenUpload: mydata.hiddenUpload2 }"
                  >
                    <el-icon><Plus /></el-icon>
                    <p class="upload-tip">点击上传组织机构代码证</p>
                  </el-upload>
                  <el-dialog v-model="mydata.dialogVisible2">
                    <img width="100%" v-complete:src="mydata.dialogImageUrl2" />
                  </el-dialog>
                </div>
              </div>
              <!-- 第三个 -->
              <div class="item" v-if="mydata.form.is_merge === 0">
                <div class="left">
                  <span>*</span>
                  <span>税务登记证:</span>
                </div>
                <div class="right">
                  <el-upload
                    :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
                    :auto-upload="true"
                    v-model:file-list="mydata.fileList3"
                    :show-file-list="true"
                    list-type="picture-card"
                    :before-upload="beforeUpload3"
                    :on-success="successFile3"
                    :on-remove="uploadRemove3"
                    :on-preview="uploadPreview3"
                    :on-change="uploadChange3"
                    accept=".jpg,.jpeg,.png,.gif"
                    :class="{ hiddenUpload: mydata.hiddenUpload3 }"
                  >
                    <el-icon><Plus /></el-icon>
                    <p class="upload-tip">点击上传税务登记证</p>
                  </el-upload>
                  <el-dialog v-model="mydata.dialogVisible3">
                    <img width="100%" v-complete:src="mydata.dialogImageUrl3" />
                  </el-dialog>
                </div>
              </div>
              <!-- 第四个 -->
              <div class="item" v-if="mydata.form.is_merge === 0">
                <div class="left">
                  <span>*</span>
                  <span>营业执照:</span>
                </div>
                <div class="right">
                  <el-upload
                    :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
                    :auto-upload="true"
                    v-model:file-list="mydata.fileList4"
                    :show-file-list="true"
                    list-type="picture-card"
                    :before-upload="beforeUpload4"
                    :on-success="successFile4"
                    :on-remove="uploadRemove4"
                    :on-preview="uploadPreview4"
                    :on-change="uploadChange4"
                    accept=".jpg,.jpeg,.png,.gif"
                    :class="{ hiddenUpload: mydata.hiddenUpload4 }"
                  >
                    <el-icon><Plus /></el-icon>
                    <p class="upload-tip">点击上传营业执照</p>
                  </el-upload>
                  <el-dialog v-model="mydata.dialogVisible4">
                    <img width="100%" v-complete:src="mydata.dialogImageUrl4" />
                  </el-dialog>
                </div>
              </div>
              <!-- 第五个 -->
              <div class="item">
                <div class="left">
                  <span>*</span>
                  <span>法人身份证:</span>
                </div>
                <div class="right">
                  <el-upload
                    :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
                    :auto-upload="true"
                    v-model:file-list="mydata.fileList5"
                    :show-file-list="true"
                    list-type="picture-card"
                    :before-upload="beforeUpload5"
                    :on-success="successFile5"
                    :on-remove="uploadRemove5"
                    :on-preview="uploadPreview5"
                    :on-change="uploadChange5"
                    accept=".jpg,.jpeg,.png,.gif"
                    :class="{ hiddenUpload: mydata.hiddenUpload5 }"
                  >
                    <el-icon><Plus /></el-icon>
                    <p class="upload-tip">点击上传营业执照</p>
                  </el-upload>
                  <el-dialog v-model="mydata.dialogVisible5">
                    <img width="100%" v-complete:src="mydata.dialogImageUrl5" />
                  </el-dialog>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>

      <div class="last-box">
        <!-- 已读勾选框 -->
        <div class="isChecked-box">
          <el-checkbox
            v-model="mydata.form.agreement_name_bol"
            size="large"
            class="login-checkbox"
          >
            <p class="text">
              我已阅读并同意
              <!-- <span @click="agreementFn">《天利出版物代理销售承诺书》</span> -->
            </p>
          </el-checkbox>
          <span @click="mydata.dialog = true"
            >《天利出版物代理销售承诺书》</span
          >
        </div>
        <!-- 提交按钮 -->
        <el-button type="primary" @click="submitList" :loading="mydata.btnLoading"
          >提交申请</el-button
        >
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog v-model="mydata.dialogVisible" title="Tips" width="343">
      <div>
        <p>审核资质注意事项</p>
        <ul>
          <li>一：需要提交的资料</li>
        </ul>
        <p>a.店铺所在平台</p>
        <p>b.店铺名称</p>
        <p>c.店铺链接</p>
        <p>c.d.店铺联系人及详细地址和通讯方式</p>
        <p>e.公司名称及简介</p>
        <p>
          f.出版物经营许可证、营业执照或三证合一证件，要求为JPG格式图片，清晰可辨，图片大小2M以内。
        </p>
        <p>g.法人身份证照片</p>

        :我方审核通过后，收取保证金 二款 膏要您支 金。汇款 怅户 签订
        收到天利邮客 议后,签字盖 寄给天 a.保证金汇出后，请联系电话:010-61421246
        QQ:3443761714确认收款。 三:签订授权协议，发送授权书。. 四:后期监督维护，
      </div>
    </el-dialog>

    <!-- 弹窗(协议) -->
    <el-dialog
      class="agreement-box"
      v-model="mydata.dialog"
      
      width="343"
    >
      <div>
        <!-- <p>{{mydata.getAgreementObj.title}}</p> -->

        <!-- <p>{{ mydata.getAgreementObj.value }}</p> -->
         <p v-html="mydata.getAgreementObj.value"></p>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

import { reactive, computed, ref } from "vue";
// import { ElMessage } from 'element-plus'
import { ComponentSize, FormInstance, FormRules } from "element-plus";

import { Delete, Download, Plus, ZoomIn } from "@element-plus/icons-vue";

import { UploadFile, ElMessage } from "element-plus";

// 引入手机号验证码发送、销售授权申请、获取店铺平台列表、获取协议接口；
import {
  certPhonCode,
  certificationSubmit,
  store_Platform,
  getAgreement,
} from "@/api/distributionAuthorization/authorizedOnlineShop/progressStep1/index.js";

// 引入申请状态查询
import { queryCode } from "@/api/distributionAuthorization/authorizedOnlineShop/queryProgressStep/index.js";

//验证是否为手机号
import { isPhoneNumber } from "@/utils/validate.js";

const router = useRouter();

const myForm = ref(null);

const mydata = reactive({
  provinceList:JSON.parse(localStorage.getItem("provinceType2")) ?? [],
  xx: "/api/sale_auth/upload_file",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  btnText: "获取验证码",
  btnDisabled: false,
  protocolchecked: false, //是否已读

  dialogVisible: false,
  dialog: false,
  size: "default",
  upload: {
    dialogImageUrl: "",
    dialogVisible: "",
    disabled: false,
  },
  form: {
    // platform: "",
    shop_platform: "", //店铺平台id
    // name: "",
    shop_name: "", //店铺名称
    // link: "",
    shop_url: "", //店铺链接

    province: "", //店铺省份

    contact: "", //联系人
    qq: "", //qq号码
    phone: "", //电话号码

    phone_code: "", //手机验证码

    company_name: "", //公司名称

    company_number: "", //组织结构代码

    address: "", //公司地址

    intro: "", //公司简介

    is_merge: 0, //是否三合一(否：0，是：1)

    agreement_name: "", // 协议名称
    agreement_name_bol: "", // 是否勾选了协议

    publication_license: "", // 出版物许可证
    company_number_img: "", // 组织机构代码证
    tax_certificate: "", // 税务登记证书
    business_license: "", // 营业执照
    identity_card: "", // 法人身份证
  },

  rules: {
    shop_platform: [
      {
        required: true,
        message: "请填写店铺平台",
      },
    ],
    shop_name: [
      {
        required: true,
        message: "请填写店铺名称",
      },
    ],

    shop_url: [
      {
        required: true,
        message: "请填写店铺链接",
      },
    ],
    province: [
      {
        required: true,
        message: "请选择省份",
      },
    ],
    contact: [
      {
        required: true,
        message: "请天写联系人",
      },
    ],
    qq: [
      {
        required: true,
        message: "请填写qq号码",
      },
    ],
    phone: [
      {
        required: true,
        message: "请填写电话号码",
      },
      { min: 11, max: 11, message: "请输入11位电话号码", trigger: "blur" },
    ],

    phone_code: [
      {
        required: true,
        message: "请填写手机验证码",
        trigger: "change",
      },
    ],

    company_name: [
      {
        required: true,
        message: "请填写公司名称",
      },
    ],
    company_number: [
      {
        required: true,
        message: "请输入组织机构代码或18位统一社会信用代码",
      },
    ],
    address: [
      {
        required: true,
        message: "请准确填写通讯地址，以确保能收到快递",
      },
    ],
    intro: [
      {
        required: true,
        message: "公司简介至少输入50个字",
      },
    ],
    is_merge: [
      {
        required: true,
        message: "请选择是否三合一",
      },
    ],
    // 出版物许可证
    publication_license: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    // 组织机构代码证
    company_number_img: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    // 税务登记证书
    tax_certificate: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    // 营业执照
    business_license: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    // 法人身份证
    identity_card: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    file_arr: [
      {
        required: true,
        message: "请上传文件",
        validator: file_arr_fn,
      },
    ],
  },
  // 第一个
  hiddenUpload1: false,
  dialogVisible1: false,
  dialogImageUrl1: "",
  fileList1: [],
  fiveM1: 1024 * 1024 * 5, // 单位字节B
  // 第二个
  hiddenUpload2: false,
  dialogVisible2: false,
  dialogImageUrl2: "",
  fileList2: [],
  fiveM2: 1024 * 1024 * 5, // 单位字节B
  // 第三个
  hiddenUpload3: false,
  dialogVisible3: false,
  dialogImageUrl3: "",
  fileList3: [],
  fiveM3: 1024 * 1024 * 5, // 单位字节B
  // 第四个
  hiddenUpload4: false,
  dialogVisible4: false,
  dialogImageUrl4: "",
  fileList4: [],
  fiveM4: 1024 * 1024 * 5, // 单位字节B
  // 第五个
  hiddenUpload5: false,
  dialogVisible5: false,
  dialogImageUrl5: "",
  fileList5: [],
  fiveM5: 1024 * 1024 * 5, // 单位字节B

  checked1: false,

  btnLoading: false,

  storePlatformArr: [], //店铺平台列表

  getAgreementObj: {}, //获取协议
});

function file_arr_fn(rule, value, callback) {
  // console.log(mydata.form.is_merge);
  // console.log(mydata.form);

  // 如果没有合并
  if (mydata.form.is_merge === 0) {
    if (
      mydata.form.publication_license &&
      mydata.form.company_number_img &&
      mydata.form.tax_certificate &&
      mydata.form.business_license &&
      mydata.form.identity_card
    ) {
      callback();
    } else {
      callback(new Error("请上传文件"));
    }
  } else {
    if (
      mydata.form.publication_license &&
      mydata.form.business_license &&
      mydata.form.identity_card
    ) {
      callback();
    } else {
      callback(new Error("请上传文件"));
    }
  }

  // business_license
}

///////////////////////////////////////////////////////
//店铺平台
function storePlatformlist() {
  //店铺平台列表
  store_Platform({}).then((res) => {
    // console.log(res, "1222");
    mydata.storePlatformArr = res.data;
  });
}

storePlatformlist();

////////////////////////////////////////////////////////

function isMergeChange() {
  mydata.fileList1 = [];
  mydata.fileList2 = [];
  mydata.fileList3 = [];
  mydata.fileList4 = [];
  mydata.fileList5 = [];
  mydata.hiddenUpload1 = false;
  mydata.hiddenUpload2 = false;
  mydata.hiddenUpload3 = false;
  mydata.hiddenUpload4 = false;
  mydata.hiddenUpload5 = false;
  mydata.form.publication_license = ""; // 出版物许可证
  mydata.form.company_number_img = ""; // 组织机构代码证
  mydata.form.tax_certificate = ""; // 税务登记证书
  mydata.form.business_license = ""; // 营业执照
  mydata.form.identity_card = ""; // 法人身份证
}

//获取验证码,按钮点击事件
function submit() {
  // 如果不是手机号，那么提醒弹窗并终止代码
  if (isPhoneNumber(mydata.form.phone) === false) {
    ElMessage({
      message: "手机号码格式错误",
      type: "warning",
    });
    return;
  }

  mydata.btnDisabled = true;
  let num = 60;
  let intervalId = setInterval(() => {
    num = num - 1;
    mydata.btnText = num + "秒后可重发";
    if (num === 0) {
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    }
  }, 1000);

  // 调用certPhonCode方法，发送请求
  certPhonCode({
    phone: mydata.form.phone,
  }).then((res) => {
    // console.log(res.data, "手机号获取验证码");
    // 存储后端返回的用户信息
    // localStorage.setItem("userInfo", JSON.stringify(res.data));
    // // 提示弹窗
    ElMessage({
      message: res.msg,
      type: "success",
    });
    // // 跳转页面
    // router.push({
    //   path: "/login/retrievePasswordLogin",
    // });
  }).catch((err)=>{
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
  })
}
///////////////////////////////////////////////////////
//提交申请事件函数
function submitList() {
  // 如果没有勾选协议
  if (!mydata.form.agreement_name_bol) {
    // 提示弹窗
    ElMessage({
      message: "请在勾选协议后进行注册或登录",
      type: "warning",
    });
    // 终止执行
    return;
  }
  // console.log(mydata.form);
  myForm.value.validate((valid, fields) => {
    if (valid) {
      // console.log("ok");
      // //销售授权申请发送请求
      certificationSubmit(mydata.form).then((res) => {
        // console.log(res.data, "提交");
        // 存储后端返回的用户信息
        // localStorage.setItem("userInfo", JSON.stringify(res.data));
        // 提示弹窗
        ElMessage({
          message: "提交成功",
          type: "success",
        });

        // 查询进度
        queryCode({ query_code: res.data.query_code }).then((res) => {
          // 跳转页面
          router.push({
            path: "/layout/list/progressStep",
            query: {
              step: 2,
              data: JSON.stringify(res.data),
            },
          });
        });
      });
    }
  });
}

////////////////////////////////////////////////////////////////
//获取协议
function agreementFn() {
  getAgreement({}).then((res) => {
    // console.log(res, "获取协议");
    mydata.getAgreementObj = res.data;
    mydata.form.agreement_name = res.data.name;
  });
}

agreementFn();

///////////////////////////////////////////////////////
// 第一个---出版物许可证------/////////////////////////////////////////////////
/**
 * 文件上传之前的钩子（返回false停止上传）
 * rawFile      即将上传的那个文件的原始文件信息
 */
function beforeUpload1(rawFile) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (rawFile.size > mydata.fiveM1) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 返回内容
    return false;
  }
}

/**
 * 文件上传成功时的钩子
 * response     后端返回的信息
 * uploadFile   上传的那个文件
 * uploadFiles  已上传的文件数组
 */
function successFile1(response, uploadFile, uploadFiles) {
  // 表单赋值
  mydata.form.publication_license = mydata.fileList1
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // // 样式赋值
  mydata.hiddenUpload1 = mydata.fileList1.length !== 0 ? true : false;
}

/**
 * 文件列表移除文件时的钩子
 * uploadFile   删除的那个文件
 * uploadFiles  剩下的文件数组
 */
function uploadRemove1(uploadFile, uploadFiles) {
  // 文件列表赋值
  mydata.fileList1 = uploadFiles;
  // 表单赋值
  mydata.form.publication_license = mydata.fileList1
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // 样式赋值
  mydata.hiddenUpload1 = mydata.fileList1.length !== 0 ? true : false;
}

/**
 * 点击文件列表中已上传的文件时的钩子
 * uploadFile 点击的那个文件
 */
function uploadPreview1(uploadFile) {
  // 显示弹窗
  mydata.dialogVisible1 = true;
  // 图片赋值
  mydata.dialogImageUrl1 = uploadFile.url;
}

/**
 * 文件状态改变时的钩子（上传文件、上传成功、上传失败的时候触发）
 * uploadFile   上传的那个文件
 * uploadFiles  已上传的文件数组
 */
function uploadChange1(uploadFile, uploadFiles){
  // 样式赋值
  mydata.hiddenUpload1 = uploadFiles.length !== 0 ? true : false;
}
//////////////////////////////////////////////////////////////////////////////////////////

// 第二个  组织机构代码证/////////////////////////////////////////////////
function beforeUpload2(rawFile) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (rawFile.size > mydata.fiveM2) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 返回内容
    return false;
  }
}

function successFile2(response, uploadFile, uploadFiles) {
  // 表单赋值
  mydata.form.company_number_img = mydata.fileList2
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // 样式赋值
  mydata.hiddenUpload2 = mydata.fileList2.length !== 0 ? true : false;
}

function uploadRemove2(uploadFile, uploadFiles) {
  // 文件列表赋值
  mydata.fileList2 = uploadFiles;
  // 表单赋值
  mydata.form.company_number_img = mydata.fileList2
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // 样式赋值
  mydata.hiddenUpload2 = mydata.fileList2.length !== 0 ? true : false;
}

function uploadPreview2(uploadFile) {
  // 显示弹窗
  mydata.dialogVisible2 = true;
  // 图片赋值
  mydata.dialogImageUrl2 = uploadFile.url;
}

function uploadChange2(uploadFile, uploadFiles){
  // 样式赋值
  mydata.hiddenUpload2 = uploadFiles.length !== 0 ? true : false;
}



// 第三个 税务登记证书 /////////////////////////////////////////////////
function beforeUpload3(rawFile) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (rawFile.size > mydata.fiveM3) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 返回内容
    return false;
  }
}

function successFile3(response, uploadFile, uploadFiles) {
  // 表单赋值
  mydata.form.tax_certificate = mydata.fileList3
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // 样式赋值
  mydata.hiddenUpload3 = mydata.fileList3.length !== 0 ? true : false;
}

function uploadRemove3(uploadFile, uploadFiles) {
  // 文件列表赋值
  mydata.fileList3 = uploadFiles;
  // 表单赋值
  mydata.form.tax_certificate = mydata.fileList3
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // 样式赋值
  mydata.hiddenUpload3 = mydata.fileList3.length !== 0 ? true : false;
}

function uploadPreview3(uploadFile) {
  // 显示弹窗
  mydata.dialogVisible3 = true;
  // 图片赋值
  mydata.dialogImageUrl3 = uploadFile.url;
}

function uploadChange3(uploadFile, uploadFiles){
  // 样式赋值
  mydata.hiddenUpload3 = uploadFiles.length !== 0 ? true : false;
}

// 第四个 营业执照/////////////////////////////////////////////////
function beforeUpload4(rawFile) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (rawFile.size > mydata.fiveM4) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 返回内容
    return false;
  }
}

function successFile4(response, uploadFile, uploadFiles) {
  // 表单赋值
  mydata.form.business_license = mydata.fileList4
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // 样式赋值
  mydata.hiddenUpload4 = mydata.fileList4.length !== 0 ? true : false;
}

function uploadRemove4(uploadFile, uploadFiles) {
  // 文件列表赋值
  mydata.fileList4 = uploadFiles;
  // 表单赋值
  mydata.form.business_license = mydata.fileList4
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // 样式赋值
  mydata.hiddenUpload4 = mydata.fileList4.length !== 0 ? true : false;
}

function uploadPreview4(uploadFile) {
  // 显示弹窗
  mydata.dialogVisible4 = true;
  // 图片赋值
  mydata.dialogImageUrl4 = uploadFile.url;
}

function uploadChange4(uploadFile, uploadFiles){
  // 样式赋值
  mydata.hiddenUpload4 = uploadFiles.length !== 0 ? true : false;
}

// 第五个 法人身份证/////////////////////////////////////////////////
function beforeUpload5(rawFile) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (rawFile.size > mydata.fiveM5) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 返回内容
    return false;
  }
}

function successFile5(response, uploadFile, uploadFiles) {
  // 表单赋值
  mydata.form.identity_card = mydata.fileList5
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // 样式赋值
  mydata.hiddenUpload5 = mydata.fileList5.length === 2 ? true : false;
}

function uploadRemove5(uploadFile, uploadFiles) {
  // 文件列表赋值
  mydata.fileList5 = uploadFiles;
  // 表单赋值
  mydata.form.identity_card = mydata.fileList5
    .map((item) => {
      return item.response.data.url;
    })
    .join(",");
  // 样式赋值
  mydata.hiddenUpload5 = mydata.fileList5.length === 2 ? true : false;
}

function uploadPreview5(uploadFile) {
  // 显示弹窗
  mydata.dialogVisible5 = true;
  // 图片赋值
  mydata.dialogImageUrl5 = uploadFile.url;
}

function uploadChange5(uploadFile, uploadFiles){
  // 样式赋值
  mydata.hiddenUpload5 = uploadFiles.length === 2 ? true : false;
}




</script>

<style scoped lang="scss">

.books-details {
  background-color: #f9f9f9;
  overflow: hidden !important;
  // margin-top:16px;
 
  /////////提示2————整个提示框
    :deep(.el-alert.el-alert--warning.is-light) {
      // width: px;
      height: 40px;
      margin: 0 auto;
      // border: 1px solid #0c181f;
      // background-color: #e6f7ff;
      border: 1px solid transparent;
      background-color: transparent;
      border-radius: 0px;
      margin-bottom: 10px;
      cursor: pointer;
      //图标
      .el-icon.el-alert__icon {
        color: #1890ff;
        width: 16px;
        height: 16px;
        margin-left: -17px;
      }
      ///字体
      .el-alert__title {
        color: #000000a6;
        font-size: 14px;
        font-weight: 400;
      }

      //// x号
      .el-icon.el-alert__close-btn {
        display: none;
        // color:red;
      }
    }

  

  //////内容 2 ////////////////////////////////////
  .content-box2 {
    width: 375px;
    // height: 720px;
    margin: 0 auto;
    padding:16px 16px 40px 16px;
    // border-radius: 0px 0px 8px 8px;
    // border: 1px solid red;
    background-color: #ffffff;
    // border-bottom:1px solid  #dcdee2;

    /////////提示2————整个提示框
    :deep(.el-alert.el-alert--warning.is-light) {
      width: 343px;
      height: 24px;
      margin: 0 auto;
      
      // background-color: #e6f7ff;
      border: 1px solid transparent;
      background-color: transparent;
      // border: 1px solid #91d5ff ;
      border-radius: 0px;
      margin-bottom: 30px;
      cursor: pointer;
      //图标
      .el-icon.el-alert__icon {
        color: #1890ff;
        width: 16px;
        height: 16px;
        margin-left: -17px;
      }
      ///字体
      .el-alert__title {
        color: #000000a6;
        font-size: 14px;
        font-weight: 400;
      }

      //// x号
      .el-icon.el-alert__close-btn {
        display: none;
        // color:red;
      }
    }

    /////  标题  （店铺信息、上传证件）
    .a-title {
       border-left: 4px solid #009de0;
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      padding-left: 10px;
      margin-bottom:20px;
    }
    /*  【店铺信息】 内容    */
    .some-input {
      width: 343px;
      // height: 822px;
      border: 1px solid transparent;
      margin-bottom: 40px;

      //标题字体
      :deep(.el-form-item__label-wrap){
         border:1px solid red;
        //  width:343px;
      }


     
      //下拉框、输入框 、textarea框 的长度
      :deep(.el-form-item.is-required.asterisk-left) {
        width: 343px;
        // height: 45px;
        margin-bottom: 16px;
        //字体
        .el-form-item__label {
          color: #000000;
          font-size: 14px;
          font-weight: 400;
          // line-height: 45px;
        }
      }
      //select框的高度
      :deep(.el-select__wrapper.el-tooltip__trigger.el-tooltip__trigger) {
        // border:1px solid red;
        height: 40px;
        //提示文字的行高
        .el-select__selected-item.el-select__placeholder.is-transparent > span {
          // color:red;
          line-height: 40px;
        }
      }
      //输入框的高度
      :deep(.el-input) {
        height: 40px;
        //提示字的行高
        .el-input__inner {
          // color:red;
          line-height: 40px;
        }
      }

      //textarea框
      :deep(.el-textarea__inner) {
        min-height: 90px !important;
        // border:1px solid red;
      }

      //手机验证码输入框
      :deep(.el-input.mobile-code) {
        width: 242px;
        // border-right:none !important;
        
        .el-input__wrapper{
          border-radius:4px 0px 0px 4px !important;
        }
      }
       //手机验证码按钮
      :deep(.el-button) {
        width: 100px;
        height:40px;
        margin-left: 0px;
        border: 1px solid #cacacd;
        border-left:none;
        border-radius:0px 4px 4px 0px;
        background-color: #fbfbfb;
        > span {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
        }
      }
    }

    /*  【上传证件】 内容   */
    .upload-cards {
      // border:1px solid red;
      // margin-bottom:130px;
     //////提示3
      :deep(.el-alert.el-alert--warning.is-light) {
        width: 343px;
        height: 60px;
        margin: 0 auto;
        border: 1px solid #ffe58f;
        background-color: #fffbe6;
        border-radius: 0px;
        margin-bottom: 20px;
        margin-top: 10px;
        //图标
        .el-icon.el-alert__icon {
          color: #ffe58f;
          width: 16px;
          height: 16px;
          margin-left: 0px;
        }
        ///字体
        .el-alert__title {
          color: #000000a6;
          font-size: 14px;
          font-weight: 400;
        }

        //// x号
        .el-icon.el-alert__close-btn {
          display: none;
          // color:red;
        }
      }

      //demo-ruleForm

      //三证合一单选框
      .demo-ruleForm {
        // border: 1px solid red;
        // margin-left: -20px;
      }

      // 文件上传区域
      :deep(.el-form-item.is-required.asterisk-left) {
        // width: 1140px !important;
        // display: flex;
        // margin-left: -8px;
      }
      .upload-box {
        // width: 1140px !important;
        // display: flex;
        // flex-wrap: wrap;
        // border: 1px solid red;
        overflow: hidden;
        > .item {
          width: 340px;
          // height: 110px;
          // display: flex;
          // margin-right: 60px;
          margin-bottom: 16px;
          // border: 1px solid rgb(4, 0, 255);
          > .left {
            width: 140px;
            // text-align: right;
            > span:first-of-type {
              font-size: 14px;
              color: #ff0000;
              margin-right: 5px;
            }
            > span:last-of-type {
              font-size: 14px;
              color: #000000;
              margin-right: 5px;
            }
          }
          > .right {
            width: 200px;
            flex-shrink: 0;
            // border:1px solid red;
          }
        }
        > .item:nth-of-type(3n) {
          margin-right: 0;
        }
        > .item:nth-of-type(5) {
          // width: 680px;
          // border:1px solid red;
          > .right {
            // width: 540px;
          }
        }
      }

      // 文件上传组件-已选择文件
      :deep(.hiddenUpload .el-upload.el-upload--picture-card) {
        display: none !important;
      }
      :deep(.el-upload-list__item.is-ready) {
        width: 200px;
        height: 110px;
      }
      :deep(.el-upload-list__item.is-success) {
        width: 200px;
        height: 110px;
      }

      // 文件上传组件-未选择文件
      :deep(.el-upload.el-upload--picture-card) {
        flex-direction: column;
        width: 200px;
        height: 110px;
        background-color: #f5f6f9;
        border-color: #d9d9d9;
        > i {
          font-size: 24px;
          color: #009de0;
        }
        .upload-tip {
          margin-top: 10px;
          color: #333333;
          font-size: 14px;
        }
      }
    }

    ///////已读勾选 与 提交按钮
    .b-last {
      display: flex;
      justify-content: center;
      overflow: hidden;
    }
    .last-box {
      width: 325px;
      // border: 1px solid red;
      margin: 0 auto;
      // padding-bottom: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      overflow: hidden;
      /////是否已读盒子
      > .isChecked-box {
        // height:22px;
        display: flex;
        align-items: center;
        // border: 1px solid red;
        > span {
          color: #009de0;
          margin-top: -2px;
          cursor: pointer;
        }
      }

      ////// 按钮
      :deep(.el-button.el-button--primary) {
        width: 239px;
        height: 38px;
        border-radius: 8px;
        > span {
          font-size: 14px;
          font-weight: 400;
          // color: #000000;
        }
      }
    }
  }
}

// 提示框3
:deep(.my-alert-3) {
  height: 80px !important;
  > .el-icon.el-alert__icon.is-big {
    width: 24px !important;
    height: 24px !important;
    color: #faad14 !important;
  }
  .el-alert__title.with-description {
    color: #000 !important;
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  .el-alert__description {
    color: #000 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
  }
}

////////弹窗（协议）
:deep(.el-dialog.agreement-box) {
  min-height: 500px;
}

//弹窗
:deep(.el-dialog) {
  border-radius: 8px;
}
</style>
